module.exports = __webpack_public_path__ + "img/微信.d9254f00.png";